var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9.86842C3.5 6.39491 3.5 4.65816 4.52513 3.57908C5.55025 2.5 7.20017 2.5 10.5 2.5H13.5C16.7998 2.5 18.4497 2.5 19.4749 3.57908C20.5 4.65816 20.5 6.39491 20.5 9.86842V15.1316C20.5 18.6051 20.5 20.3418 19.4749 21.4209C18.4497 22.5 16.7998 22.5 13.5 22.5H10.5C7.20017 22.5 5.55025 22.5 4.52513 21.4209C3.5 20.3418 3.5 18.6051 3.5 15.1316V9.86842Z",
    stroke: "#252C32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.5L8.0822 2.9932C8.28174 4.19044 8.38151 4.78906 8.80113 5.14453C9.22075 5.5 9.82762 5.5 11.0414 5.5H12.9586C14.1724 5.5 14.7793 5.5 15.1989 5.14453C15.6185 4.78906 15.7183 4.19044 15.9178 2.9932L16 2.5",
    stroke: "#252C32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16.5H12M8 11.5H16",
    stroke: "#252C32",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskList);
export default __webpack_public_path__ + "static/media/task-list.ba80d2b0fcf6ddb872a09c9e175fc032.svg";
export { ForwardRef as ReactComponent };